import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDevices } from './firebase';
import {
  STATUS_FETCHING,
  STATUS_ERROR,
  STATUS_READY,
  STATUS_IDLE
} from './constants';

export const fetchDevices = createAsyncThunk('getuserDevices', async (nip) => await getDevices(nip));

const userDeviceSlice = createSlice({
  name: 'userDevice',
  initialState: {
    status: STATUS_IDLE,
    data: []
  },
  reducers: {},
  extraReducers (builder) {
    builder
      .addCase(fetchDevices.pending, (state, action) => {
        state.status = STATUS_FETCHING
      })
      .addCase(fetchDevices.fulfilled, (state, action) => {
        state.status = STATUS_READY
        state.data = action.payload
      })
      .addCase(fetchDevices.rejected, (state, action) => {
        state.status = STATUS_ERROR
        state.error = action.error.message
      })
  }
})

export default userDeviceSlice.reducer
